/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDocumentExclusionTermRequest
 */
export interface UpdateDocumentExclusionTermRequest {
    /**
     * 
     */
    term: string;
}

/**
 * Check if a given object implements the UpdateDocumentExclusionTermRequest interface.
 */
export function instanceOfUpdateDocumentExclusionTermRequest(value: object): value is UpdateDocumentExclusionTermRequest {
    if (!('term' in value) || value['term'] === undefined) return false;
    return true;
}

export function UpdateDocumentExclusionTermRequestFromJSON(json: any): UpdateDocumentExclusionTermRequest {
    return UpdateDocumentExclusionTermRequestFromJSONTyped(json, false);
}

export function UpdateDocumentExclusionTermRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDocumentExclusionTermRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'term': json['term'],
    };
}

export function UpdateDocumentExclusionTermRequestToJSON(json: any): UpdateDocumentExclusionTermRequest {
    return UpdateDocumentExclusionTermRequestToJSONTyped(json, false);
}

export function UpdateDocumentExclusionTermRequestToJSONTyped(value?: UpdateDocumentExclusionTermRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'term': value['term'],
    };
}

